import * as o from "react";
import c from "../lib/SSRBase.es.js";
import a from "../defs/CircleNotch.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(c, { ref: t, ...r, weights: a }));
e.displayName = "CircleNotchIcon";
const s = e;
export {
  s as CircleNotch,
  e as CircleNotchIcon
};
